import { Button, Flex } from '@components';
import PageNotFound from '@assets/logos/no-page-found-bg.png';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  flex: 1,
  height: '100vh',
  backgroundImage: `url(${PageNotFound})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  padding: theme.spacing(16),
  textAlign: 'center',
}));

export const StyledAppLogo = styled('img')(() => ({
  width: '100%',
  height: '100%',
  maxWidth: 150,
  maxHeight: 40,
  objectFit: 'contain',
}));

export const Styled404Logo = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  maxWidth: 300,
  maxHeight: 120,
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
    maxHeight: 80,
  },
  marginTop: theme.spacing(17),
  marginBottom: theme.spacing(16),
  objectFit: 'contain',
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: 360,
  marginTop: theme.spacing(12),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));
